"use client";
import Image from 'next/image';
import BannerImage1 from '@root/src/assets/images/banner collection 4.png';
import BannerImage2 from '@root/src/assets/images/banner collection3.png';
import BannerImage3 from '@root/src/assets/images/bannercollection.png';
import BannerImage4 from '@root/src/assets/images/banner_trang_san_pham_tra.png';

const fallbackBannerImages = [
  BannerImage1,
  BannerImage2,
  BannerImage3,
  BannerImage4,
];

interface FeaturedProductProps {
  collection: {
    name: string;
  };
}

export default function FeaturedProduct({ collection }: FeaturedProductProps) {
  const imageUrl = fallbackBannerImages[Math.floor(Math.random() * fallbackBannerImages.length)];

  return (
    <section className="featured-wrapper">
      <div className="featured-image">
        <Image src={imageUrl} alt={collection.name} fill sizes="100vw" className="featured-photo" />
      </div>

      <style jsx>{`
        .featured-wrapper {
          width: 100%;
          position: relative;
          height: clamp(220px, 32vw, 480px);
          overflow: hidden;
        }
        .featured-image {
          position: relative;
          width: 100%;
          height: 100%;
        }
        .featured-photo {
          object-fit: cover;
          object-position: center center;
        }
        @media (max-width: 768px) {
          .featured-wrapper {
            height: clamp(220px, 58vw, 340px);
          }
        }
        @media (max-width: 420px) {
          .featured-wrapper {
            height: 220px;
          }
        }
      `}</style>
    </section>
  );
}
